<template>
  <div style="margin-top: 15px; margin-right: 69px">
    <a class="heading">{{ heading }}</a>
    <Toggle color="#0054a6" :labels="label" v-model="value" @click="changeLink(value)" style="opacity: 0"></Toggle>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import VueToggles from "vue-toggles";

export default defineComponent({
  name: "SeeMoreLinkComp",
  components: {
    Toggle: VueToggles
  },
  emits: ["onToggleChange"],
  data() {
    return {
      value: false,
      heading: this.$t("seeMoreLinkComp.seeMore"),
      label: { checked: this.$t("seeMoreLinkComp.seeLess"), unchecked: this.$t("seeMoreLinkComp.seeMore") }
    };
  },
  methods: {
    changeLink(event: boolean): void {
      this.$emit("onToggleChange", event);
      if (event) this.heading = this.label.checked;
      else this.heading = this.label.unchecked;
    }
  }
});
</script>

<style scoped>
.heading {
  position: absolute;
  text-decoration: underline;
}
</style>
